module.exports = __webpack_public_path__ + "app/assets/images/man15-a98964a4bf4009d526f760e9e0190ba7.jpg";